import React, { useState } from 'react';
import { ImageInput, useNotify, useTranslate } from 'react-admin';
import { PreviewImageField } from '../../Components';

export const EVIDENCE_IMAGE_MAX_SIZE = 5 * 1024 * 1024;
export const EVIDENCE_IMAGE_ACCEPT =
  'image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp';

const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const ALLOWED_EXTS = ['.jpg', '.jpeg', '.png', '.webp'];

const isAllowedEvidenceImage = (file) => {
  if (!file) return false;
  const name = (file.name || '').toLowerCase();
  const extOk = ALLOWED_EXTS.some((ext) => name.endsWith(ext));
  if (file.type) {
    return ALLOWED_TYPES.includes(file.type) && extOk;
  }
  return extOk;
};

const filesFromRejections = (rejections = []) =>
  rejections.map((item) => item.file || item).filter(Boolean);

const codesFromRejections = (rejections = []) =>
  rejections.flatMap((item) => (item.errors || []).map((err) => err.code));

export const validateEvidenceImage = (value) => {
  const file = value?.rawFile;
  if (!file) {
    return undefined;
  }
  if (file.size > EVIDENCE_IMAGE_MAX_SIZE) {
    return 'validation.imageMaxSize';
  }
  if (!isAllowedEvidenceImage(file)) {
    return 'validation.imageInvalidType';
  }
};

const EvidenceImageInput = (props) => {
  const notify = useNotify();
  const translate = useTranslate();
  const [error, setError] = useState(null);

  const handleDropRejected = (rejections) => {
    const files = filesFromRejections(rejections);
    const codes = codesFromRejections(rejections);
    const tooLarge =
      codes.includes('file-too-large') ||
      files.some((file) => file.size > EVIDENCE_IMAGE_MAX_SIZE);
    const invalidType =
      codes.includes('file-invalid-type') ||
      files.some((file) => !isAllowedEvidenceImage(file));

    let messageKey = 'validation.imageInvalid';
    if (tooLarge && !invalidType) {
      messageKey = 'validation.imageMaxSize';
    } else if (invalidType && !tooLarge) {
      messageKey = 'validation.imageInvalidType';
    }

    const message = translate(messageKey);
    setError(message);
    notify(message, 'warning');
  };

  return (
    <>
      <ImageInput
        {...props}
        label="Upload Image File"
        accept={EVIDENCE_IMAGE_ACCEPT}
        maxSize={EVIDENCE_IMAGE_MAX_SIZE}
        placeholder={
          <p>
            Drop a jpg, jpeg, png or webp image here, or click to select it.
            <br />
            Max size 5MB
          </p>
        }
        options={{
          onDropRejected: handleDropRejected,
          onDropAccepted: () => setError(null),
        }}
      >
        <PreviewImageField />
      </ImageInput>
      {error ? (
        <div style={{ color: '#f44336', fontSize: '0.75rem', marginTop: '-8px' }}>
          {error}
        </div>
      ) : null}
    </>
  );
};

export default EvidenceImageInput;
